// ========== APP.JS MASTER SKI PILOU - SIGNATURE ÉLECTRONIQUE + SYSTEMPAY ==========

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { supabase } from './api/supabase';
import { Spin, App as AntdApp } from 'antd';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import Sidebar from './components/layout/Sidebar';
import ClientFileViewer from './components/ClientFileViewer';

import OrderManagementPage from './components/pages/orders/OrderManagementPage';
import PassportCompressor from './components/pages/passport-compressor/PassportCompressor';
import PassportAnalyzer from './components/pages/passports-analyzer/passports-analyzer';
import LunchOrdersPage from './components/pages/LunchOrders/LunchOrdersPage';
import ClientManager from './components/pages/ClientManager/ClientManager';
import PricingPage from './components/pages/PricingPage';
import YachtContract from './components/pages/YachtContract/YachtContract';
import EmployeeSchedule from './components/pages/EmployeeSchedule/EmployeeSchedule';
import PartnerLunchOrdersView from './components/pages/PartnerLunchOrderView/PartnerLunchOrderView';
import PartnerLayout from './components/layout/PartnerLayout';
import LoginPage from './components/pages/Login/LoginPage';
import FormSelectionPage from './components/pages/ContractsGenerator/FormSelectionPage';
import EmployeeListPage from './components/pages/Employee/EmployeeListPage';

// ========== DOCUMENT GENERATOR ==========
import DocumentGenerator from './components/pages/DocumentGenerator';
import DocumentListPage from './components/pages/DocumentListPage';
import PaymentTracking from './components/pages/PaymentTracking';
import ContractSignAndPay from './components/pages/ContractSignAndPay';
import CharterDocumentGenerator from './components/pages/CharterDocumentGenerator';
import TemplateGuide from './components/pages/TemplateGuide';
import TemplateValidator from './components/pages/TemplateValidator';
import MakeDocumentTest from './components/pages/MakeDocumentTest';
import OAuthCallback from './components/pages/OAuthCallback';

// ========== IMPORTS SYSTÈME LUNCH MASTER SKI PILOU ==========
import LunchReservationSystem from './components/pages/LunchReservation/LunchReservationSystem';
import ClientMenuSelection from './components/pages/LunchReservation/ClientMenuSelection';
import LunchPaymentReturn from './components/pages/LunchReservation/LunchPaymentReturn';
import LunchPaymentCancel from './components/pages/LunchReservation/LunchPaymentCancel';
import AdminConfirmationPage from './components/pages/LunchReservation/AdminConfirmationPage';

import CsvValidationWizard from './components/pages/ClientCardex/CsvValidationWizard';

import CharterAnalyticsDashboard from './components/pages/CharterAnalytics/CharterAnalytics';
import CSVCleaner from './components/pages/CsvCleaner/CsvCleaner';

// ========== JETSKI PRO MAILER ==========
import JetskiEmailSender from './components/pages/JetskiMailer/JetskiEmailSender';
import VesselUpgradeEmailSender from './components/pages/JetskiMailer/VesselUpgradeEmailSender';

// ========== CLOSING CHECKLIST ==========
import ClosingChecklist from './components/pages/ClosingChecklist/ClosingChecklist';
import CashSheetEmailSender from './components/pages/ClosingChecklist/CashSheetEmailSender';
import PlanningValidatorComponent from './components/pages/ClosingChecklist/PlanningValidatorComponent';

// ========== YACHT MANAGEMENT ==========
import YachtManagement from './components/pages/YachtManagement';

// ========== BERTH DOCUMENT GENERATOR ==========
import BerthDocumentGenerator from './components/pages/BerthDocumentGenerator';
import PDFFieldValidator from './components/pages/PDFFieldValidator';
import BerthPDFFieldValidator from './components/pages/BerthPDFFieldValidator';
import PDFFieldEditor from './components/pages/PDFFieldEditor';

// ========== SEABOB DOCUMENT GENERATOR ==========
import SeabobDocumentGenerator from './components/pages/SeabobDocumentGenerator';
import SeabobDocumentValidator from './components/pages/SeabobDocumentValidator';

// ========== JETSKI DOCUMENT GENERATOR ==========
import JetskiDocumentGenerator from './components/pages/JetskiDocumentGenerator';

// ========== LUNCH DOCUMENT GENERATOR ==========
import LunchDocumentGenerator from './components/pages/LunchDocumentGenerator';
import LunchDocumentValidator from './components/pages/LunchDocumentValidator';

// ========== CUSTOM DOCUMENT GENERATOR ==========
import CustomDocumentGenerator from './components/pages/CustomDocumentGenerator';

// ========== SHORTCUTS ==========
import Shortcuts from './components/pages/Shortcuts';
import QuickReplies from './components/pages/QuickReplies';

// ========== AGENDA DAY EDITOR ==========
import AgendaDayEditor from './components/pages/AgendaDayEditor';

// ========== KNOWLEDGE BASE ==========
import KnowledgeBase from './components/pages/KnowledgeBase';

// ========== UNIFIED CONTRACTS ==========
import UnifiedContractGenerator from './components/pages/UnifiedContractGenerator';

// ========== OFF DAYS MANAGEMENT ==========
import OffDays from './components/pages/OffDays';
import OffDatesViewer from './components/pages/OffDates/OffDatesViewer';
import OffOverview from './components/pages/OffOverview';

// ========== CLAIRANCE GUSTAVIA ==========
import ClairancePage from './components/pages/ClairancePage';
import ClairanceTracker from './components/pages/ClairanceTracker';

// ========== PASSPORT MANAGEMENT ==========
import PassportPage from './components/pages/PassportPage';

// ========== TASKS MANAGEMENT ==========
import SurLeFeu from './components/pages/SurLeFeu';
import ScheduleGeorges from './components/pages/ScheduleGeorges';
import Tickets from './components/pages/Tickets';
import TransferTracking from './components/pages/TransferTracking';

// Import additional placeholder components
const Calendar = () => <h1>Calendar</h1>;
const Crew = () => <h1>Crew Management</h1>;
const Feedbacks = () => <h1>Feedbacks</h1>;
const Contacts = () => <h1>Contacts</h1>;

// Protected Route Component
const ProtectedRoute = () => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const { theme } = useTheme();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return (
    <ProtectedLayout theme={theme} />
  );
};

// Separate layout component to prevent sidebar re-mounting
const ProtectedLayout = ({ theme }) => {
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar />
      <div
        style={{ flexGrow: 1, overflow: 'auto', backgroundColor: theme.colors.bgSecondary }}
      >
        <Outlet />
      </div>
    </div>
  );
};

// Partner Route Component
const PartnerRoute = () => {
  return (
    <PartnerLayout>
      <Outlet />
    </PartnerLayout>
  );
};

const App = () => {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  // ✅ Log de démarrage Master Ski Pilou
  useEffect(() => {
    console.log('🏝️ Master Ski Pilou - Lunch Reservation System');
    console.log('📧 Signature électronique + VoxPay Email/Web + Make webhook');
    console.log('🔧 Environment:', {
      baseUrl: process.env.REACT_APP_BASE_URL,
      voxpayApiKey: process.env.REACT_APP_VOXPAY_API_KEY ? '✅ Configured' : '❌ Missing',
      voxpayCampaign: process.env.REACT_APP_VOXPAY_CAMPAIGN_ID ? '✅ Configured' : '❌ Missing',
      makeWebhook: process.env.REACT_APP_VOXPAY_WEBHOOK ? '✅ Configured' : '❌ Missing'
    });
  }, []);

  return (
    <ThemeProvider>
      <AntdApp>
      <Router>
        <Routes>
          {/* ========== ROUTES PUBLIQUES LUNCH MASTER SKI PILOU (SANS AUTHENTIFICATION) ========== */}
        
        {/* 🎯 Interface client pour sélectionner le menu, signer et payer */}
        <Route 
          path="/lunch-reservation/:uniqueLink" 
          element={<ClientMenuSelection />} 
        />
        
        {/* 💳 Pages de retour après paiement SystemPay */}
        <Route
          path="/lunch-payment-return/:uniqueLink"
          element={<LunchPaymentReturn />}
        />
        <Route
          path="/lunch-payment-cancel/:uniqueLink"
          element={<LunchPaymentCancel />}
        />

        {/* ========== 📝 SIGNATURE ET PAIEMENT CONTRATS ========== */}
        {/* URL publique pour signature + paiement client */}
        <Route
          path="/contract/:uniqueLink"
          element={<ContractSignAndPay />}
        />

        {/* ========== ROUTES PARTNER ========== */}
        <Route element={<PartnerRoute />}>
          <Route path="/partner/lunch-orders" element={<PartnerLunchOrdersView />} />
        </Route>

        {/* ========== OAUTH CALLBACK ========== */}
        <Route path="/oauth/callback" element={<OAuthCallback />} />

        {/* ========== ROUTES PUBLIQUES ========== */}
        <Route
          path="/login"
          element={
            session ? <Navigate to="/document-list" replace /> : <LoginPage />
          }
        />

        {/* ========== ROUTES ADMIN PROTÉGÉES ========== */}
        <Route element={<ProtectedRoute />}>
          {/* Redirect root vers document list */}
          <Route path="/" element={<Navigate to="/document-list" replace />} />
          
          {/* ========== 🏝️ SYSTÈME LUNCH MASTER SKI PILOU ========== */}
          
          {/* 📋 CRM Interface admin pour gérer les réservations lunch */}
          <Route 
            path="/lunch-reservations" 
            element={<LunchReservationSystem />} 
          />
          
          {/* ✅ Page de confirmation admin (après validation) */}
          <Route 
            path="/admin/lunch-confirmation/:reservationId" 
            element={<AdminConfirmationPage />} 
          />
          
          {/* 📊 Ancien système lunch (conservé pour compatibilité) */}
          <Route path="/lunch-orders" element={<LunchOrdersPage />} />
          
          {/* ========== GESTION CLIENTS & EMPLOYÉS ========== */}
          <Route path="/client-manager" element={<ClientManager />} />
          <Route path="/employee-schedule" element={<EmployeeSchedule />} />

          {/* ========== MARKETING ========== */}
          <Route path="/clients" element={<ClientFileViewer />} />
          <Route path="/contracts-summary" element={<Navigate to="/document-list" replace />} />
          <Route path="/form-selection" element={<FormSelectionPage />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/transfer-pricing" element={<PricingPage />} />
          <Route path="/charter-pricing" element={<PricingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/shortcuts" element={<Shortcuts />} />
          <Route path="/quick-replies" element={<QuickReplies />} />

          {/* ========== UNIFIED CONTRACT GENERATOR ========== */}
          <Route path="/contracts" element={<UnifiedContractGenerator />} />

          {/* ========== DOCUMENT GENERATOR (Legacy routes kept for compatibility) ========== */}
          <Route path="/document-generator" element={<DocumentGenerator />} />
          <Route path="/document-list" element={<DocumentListPage />} />
          <Route path="/payment-tracking" element={<PaymentTracking />} />
          <Route path="/charter-document-generator" element={<CharterDocumentGenerator />} />
          <Route path="/seabob-documents" element={<SeabobDocumentGenerator />} />
          <Route path="/jetski-documents" element={<JetskiDocumentGenerator />} />
          <Route path="/lunch-documents" element={<LunchDocumentGenerator />} />
          <Route path="/custom-documents" element={<CustomDocumentGenerator />} />
          <Route path="/template-guide" element={<TemplateGuide />} />
          <Route path="/template-validator" element={<TemplateValidator />} />
          <Route path="/make-document-test" element={<MakeDocumentTest />} />

          {/* ========== FLEET & CREW ========== */}
          <Route path="/crew" element={<Crew />} />
          <Route path="/employee-list" element={<EmployeeListPage />} />
          <Route path="/yacht-contract" element={<YachtContract />} />
          <Route path="/yacht-management" element={<YachtManagement />} />
          <Route path="/cardex" element={<CsvValidationWizard />} />

          {/* ========== HUB ========== */}
          <Route path="/orders-page" element={<OrderManagementPage />} />
          <Route path="/feedbacks" element={<Feedbacks />} />
          <Route path="/contacts" element={<Contacts />} />

          {/* ========== TOOLS ========== */}
          <Route path="/compress-passports" element={<PassportCompressor />} />
          <Route path="/passport-analyzer" element={<PassportAnalyzer />} />
          <Route path="/csv-uploader" element={<CSVCleaner/>} />
          <Route path="/charter-analytics" element={<CharterAnalyticsDashboard/>} />
          <Route path="/jetski-mailer" element={<JetskiEmailSender />} />
          <Route path="/vessel-upgrade" element={<VesselUpgradeEmailSender />} />

          {/* ========== CLOSING CHECKLIST ========== */}
          <Route path="/closing-checklist" element={<ClosingChecklist />} />
          <Route path="/cash-sheet-email" element={<CashSheetEmailSender />} />
          <Route path="/berth-documents" element={<BerthDocumentGenerator />} />
          <Route path="/berth-pdf-validator" element={<BerthPDFFieldValidator />} />
          <Route path="/pdf-field-validator" element={<PDFFieldValidator />} />
          <Route path="/pdf-field-editor" element={<PDFFieldEditor />} />
          <Route path="/seabob-validator" element={<SeabobDocumentValidator />} />
          <Route path="/lunch-validator" element={<LunchDocumentValidator />} />
          <Route path="/planning-validator" element={<PlanningValidatorComponent />} />
          <Route path="/off-days" element={<OffDays />} />
          <Route path="/off-overview" element={<OffOverview />} />
          <Route path="/off-dates-viewer" element={<OffDatesViewer />} />
          <Route path="/clairance" element={<ClairancePage />} />
          <Route path="/clairance-tracker" element={<ClairanceTracker />} />
          <Route path="/passports" element={<PassportPage />} />
          <Route path="/sur-le-feu" element={<SurLeFeu />} />
          <Route path="/schedule-georges" element={<ScheduleGeorges />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/transfer-tracking" element={<TransferTracking />} />

          {/* ========== AGENDA DAY EDITOR ========== */}
          <Route path="/agenda-editor" element={<AgendaDayEditor />} />

          {/* ========== KNOWLEDGE BASE ========== */}
          <Route path="/connaissances" element={<KnowledgeBase />} />

        </Route>

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
      </AntdApp>
    </ThemeProvider>
  );
};

export default App;

// ========== SYSTÈME MASTER SKI PILOU - NOTES DE CONFIGURATION ==========
/*
🏝️ MASTER SKI PILOU - LUNCH RESERVATION SYSTEM

✅ FONCTIONNALITÉS IMPLÉMENTÉES:
1. 📝 Signature électronique sur canvas
2. 💳 Paiement via lien SystemPay sécurisé  
3. 📧 Notifications email via Make webhook
4. 📄 Génération PDF contrat avec signature
5. 🔍 Validation manuelle CRM avant confirmation client
6. ✅ Email confirmation automatique avec PDF attaché
7. 📨 JetSki Pro Mailer - Envoi automatique emails de réservation

🔄 WORKFLOW COMPLET:
1. Client sélectionne menu → Status: "selected"
2. Client signe électroniquement → Status: "signed" 
3. Client clique paiement SystemPay → Status: "paid" + Email notification
4. Admin valide dans CRM → Status: "confirmed" + Email client
5. Client reçoit confirmation finale avec PDF

📧 EMAILS AUTOMATIQUES:
- Notification Master Ski Pilou: Après signature + paiement
- Confirmation Client: Après validation admin (avec PDF)
- JetSki Booking: Confirmation de réservation jetski avec lien de paiement

🌐 ROUTES PUBLIQUES:
- /lunch-reservation/:uniqueLink (Interface client)
- /lunch-payment-return/:uniqueLink (Retour SystemPay)
- /lunch-payment-cancel/:uniqueLink (Annulation paiement)

🔒 ROUTES ADMIN:
- /lunch-reservations (CRM gestion réservations)
- /admin/lunch-confirmation/:reservationId (Page confirmation)
- /jetski-mailer (JetSki Pro Mailer)

⚙️ VARIABLES D'ENVIRONNEMENT REQUISES:
- REACT_APP_MAKE_NOTIFICATION_WEBHOOK (notifications Master Ski Pilou)
- REACT_APP_MAKE_CONFIRMATION_WEBHOOK (confirmations clients)
- REACT_APP_BASE_URL (domaine principal)

🎯 SYSTEMPAY CONFIGURATION:
- URL de retour: /lunch-payment-return/:uniqueLink
- URL d'annulation: /lunch-payment-cancel/:uniqueLink
- Identifiant: MASTERSKI_PILOU

✅ PRÊT POUR PRODUCTION
*/